import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=4a9a3a24&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=4a9a3a24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a3a24",
  null
  
)

export default component.exports